import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './wrap.styl'

export default class LogWrap extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
